export default {
    name: 'not-found',
    path: '*',
    component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue'),
}